import { getUserList } from '@/services/userSettings';
export async function fetchUserList(filters, orderBy, page, limit, statusFilter) {
    const args = {
        ...(filters.length && { query: JSON.stringify(filters) }),
        ...(statusFilter && { active: statusFilter }),
        orderBy,
    };
    const data = await getUserList(limit, page, args);
    return formatUsers(data);
}
function formatClientUsers(clientData) {
    return clientData.users.map(apiUser => formatUser(apiUser, clientData.client_id));
}
function extractBrands(accounts) {
    return accounts.map(account => account.account);
}
function extractProfileName(apiUser) {
    return apiUser.access?.profile ?? apiUser.groups?.group ?? '';
}
function extractProfileId(apiUser) {
    return apiUser.access?.id ?? apiUser.groups?.id ?? 0;
}
function formatUser(apiUser, clientId) {
    const brands = extractBrands(apiUser.accounts);
    const firstAccount = apiUser.accounts[0];
    return {
        id: apiUser.id,
        name: apiUser.name,
        email: apiUser.login,
        brands,
        client: {
            clientId,
            id: firstAccount?.id ?? 0,
            name: firstAccount?.account ?? '',
            hasMultipleAccounts: apiUser.accounts.length > 1,
        },
        profile: {
            name: extractProfileName(apiUser),
            id: extractProfileId(apiUser),
            description: apiUser.access?.description ?? '',
        },
        enabled: apiUser.enabled,
        isLocked: apiUser.is_locked,
        user360: apiUser.user_360,
    };
}
function formatUsers(data) {
    const formattedUsers = data.flatMap(clientData => formatClientUsers(clientData));
    const totalCount = data[0].count;
    return {
        users: formattedUsers,
        totalCount,
    };
}
